<ng-container *ngIf="options?.length > 0; then subMenuBlock; else noSubMenuBlock"></ng-container>
<ng-template #noSubMenuBlock>
    <button (click)="menuClicked($event)" title="{{ label }}" mat-button
        class="pepperi-menu pepperi-button icon-button weak {{ layoutType === LAYOUT_TYPE.PepperiTable ? 'sm' : 'md' }}"
        [ngClass]="{
            'lock-events': disabled,
            'left-alignment': xAlignment == '1' || xAlignment == '0',
            'right-alignment': xAlignment == '2',
            'center-alignment': xAlignment == '3',
            'invert': invertClass
        }">
        <mat-icon>
            <pep-icon name="system_menu">
            </pep-icon>
        </mat-icon>
    </button>
</ng-template>

<ng-template #subMenuBlock>
    <button mat-button [matMenuTriggerFor]="menu" menu-blur
        class="pepperi-menu pepperi-button icon-button weak {{ layoutType === LAYOUT_TYPE.PepperiTable ? 'sm' : 'md' }}"
        [ngClass]="{
            'left-alignment': xAlignment == '1' || xAlignment == '0',
            'right-alignment': xAlignment == '2',
            'center-alignment': xAlignment == '3',
            'invert': invertClass
        }" title="{{ label }}">
        <mat-icon>
            <pep-icon name="system_menu">
            </pep-icon>
        </mat-icon>
    </button>

    <mat-menu #menu="matMenu" xPosition="{{xAlignment == '2' ? 'after' : 'before'}}"
        [ngClass]="{ rtlMenu: xAlignment == '2' }">
        <button *ngFor="let option of options" mat-menu-item (click)="menuItemClicked(option.Key)">
            <span>{{ option.Value | translate }}</span>
        </button>
    </mat-menu>

</ng-template>
